<template>
  <div id="detail" class="hotel_container">
    <div class="hotel_container_panel">
      <Loading :loading="allLoading" />
      <el-breadcrumb v-if="$objBaseInfo.channelId === 'WEB'" separator-class="el-icon-arrow-right" style="height: 5rem; line-height: 5rem">
        <el-breadcrumb-item>{{ $t("DETAIL.HOME") }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t("DETAIL.HOTELRESULT") }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t("DETAIL.DETAILPAGE") }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div v-if="$objBaseInfo.channelId === 'MOBILE'">
        <div class="mainBox">
          <el-row>
            <el-col :span="24">
              <el-carousel class="carousel-image" ref="carousel" arrow="always" :autoplay="false" indicator-position="none">
                <el-carousel-item v-for="(item, index) in PhotoList" :key="index">
                  <el-image class="imgStyle" fit="fill" :src="
                      item.url
                        ? item.url
                        : require('@/assets/img/hotel_img_error.png')
                    " :onerror="defaultImg">
                  </el-image>
                </el-carousel-item>
              </el-carousel>
            </el-col>
          </el-row>
        </div>
        <div class="detailContent">
          <ul>
            <li>
              <h1 style="color: #222A30; font-family: 'Source-Sans-Bold';">{{ $i18n.locale == "en" ? this.nameEn : this.nameCh }}</h1>
            </li>
            <li style="display: flex; align-items: center;">
              <span v-if="standardStar > 0">
                <el-rate v-model="standardStar" disabled class="my-rate-reform" :colors="['#F2A900', '#F2A900', '#F2A900']">
                </el-rate>
              </span>
              <span v-else>
               <span v-for="n in starRating" :key="n">
                  <svg-icon icon-class="hotel_icon_diamond" style="height: 13px;width:18px;padding-right:0"></svg-icon>
                </span>
              </span>
              <span v-if="emission && emission.score >= 45" style="display: flex; align-items: center;">
                <span style="margin-right: -.3rem;color: #E7E9EA;">{{ separator}}</span>
                <svg-icon icon-class="emission" style="height: 1.7rem;vertical-align: -0.4em;padding-right: 0;"></svg-icon>
                <span style="color: #222A30; font-family: 'Source Sans Pro'; vertical-align: middle; display: inline-block;">{{ $t("RESULT.EMISSION")}}</span>
              </span>
            </li>
            <li style="color: #838A90;font-family: 'Source-Sans-Pro-Regular';">
              <svg-icon icon-class="phone" class-name="svg"></svg-icon>{{ this.contactNumber }}
            </li>
            <li style="color: #838A90;font-family: 'Source-Sans-Pro-Regular';">
              <svg-icon icon-class="location" class-name="svg"></svg-icon><span>{{
                $i18n.locale == "en" ? this.addressEn : this.addressCh
              }}</span>
            </li>
            <li class="wordList">
              <svg-icon icon-class="hotel" class-name="svg"></svg-icon>{{
                $i18n.locale == "en" ? this.descriptionEn : this.descriptionCh
              }}
            </li>
            <li v-if="this.openedAt">
              <svg-icon icon-class="openedAt" class-name="svg"></svg-icon>{{ this.$t("DETAIL.OPENEDAT", { openedAt: this.openedAt }) }}
            </li>
            <li v-if="this.decoratedAt">
              <svg-icon icon-class="decoratedAt" class-name="svg"></svg-icon>{{ this.$t("DETAIL.DECORATEDAT", { decoratedAt: this.decoratedAt })}}
            </li>
          </ul>
          <div v-show="isShowMap" class="showMap" @click="goMap(locationArr)">
            <svg-icon icon-class="ic_map" class-name="show-map-icon"></svg-icon>
            <span>
              {{ $t("DETAIL.SHOWONMAP") }}
            </span>
          </div>
        </div>
      </div>

      <!--begin detail image-->
      <div class="div_hotel_detail" v-if="$objBaseInfo.channelId === 'WEB'">
        <div class="div_hotel_detail_l" style="width: auto;">
          <ul>
            <li style="display: flex; align-items: center;">
              <h1>{{ $i18n.locale == "en" ? this.nameEn : this.nameCh }}</h1>
                <span v-if="standardStar > 0">
                  <el-rate v-model="standardStar" disabled class="my-rate-reform" :colors="['#F2A900', '#F2A900', '#F2A900']">
                  </el-rate>
                </span>
                <span v-else>
                  <span v-for="n in starRating" :key="n">
                    <svg-icon icon-class="hotel_icon_diamond" style="height: 13px;width:18px;padding-right:0"></svg-icon>
                  </span>
                </span>
                <span v-if="emission && emission.score >= 45">
                  <span style="margin-right: -.7rem;color: #E7E9EA;">{{ separator}}</span>
                  <svg-icon icon-class="emission" style="height: 17px;vertical-align: -0.4em;padding-right: 0;"></svg-icon>
                  <span style="color: #222A30; font-family: 'Source Sans Pro'; vertical-align: middle; display: inline-block;">{{ $t("RESULT.EMISSION")}}</span>
                </span>
            </li>
          </ul>
        </div>
        <div class="div_hotel_detail_text">
          <div class="div_hotel_detail_l">
            <ul>
              <li v-if="this.$objBaseInfo.sourceType == 'CRM'">
                FXId: {{ this.hotelcode }}
              </li>
              <li style="color: #838A90; font-family: 'Source Sans Pro';">
                <svg-icon icon-class="phone" class-name="svg"></svg-icon>{{ this.contactNumber }}
              </li>
              <li style="color: #838A90; font-family: 'Source Sans Pro';">
                <svg-icon icon-class="location" class-name="svg"></svg-icon><span>{{
                  $i18n.locale == "en" ? this.addressEn : this.addressCh
                }}</span>
              </li>
              <li class="wordList">
                <svg-icon icon-class="hotel" class-name="svg"></svg-icon>{{
                  $i18n.locale == "en" ? this.descriptionEn : this.descriptionCh
                }}
              </li>
              <li v-if="this.openedAt">
                <svg-icon icon-class="openedAt" class-name="svg"></svg-icon>{{ this.$t("DETAIL.OPENEDAT", { openedAt: this.openedAt }) }}
              </li>
              <li v-if="this.decoratedAt">
                <svg-icon icon-class="decoratedAt" class-name="svg"></svg-icon>{{ this.$t("DETAIL.DECORATEDAT", { decoratedAt: this.decoratedAt })}}
              </li>
            </ul>
          </div>
          <div class="more_detail" v-if="this.descriptionEn != 'N/A' && $i18n.locale == 'en'">
            <a style="color: #1061cc" class="more_detail_btn" href="#description" @click="changeTab('description', 'click')">more
            </a>
          </div>
          <div class="more_detail" v-if="this.descriptionCh != 'N/A' && $i18n.locale == 'zh'">
            <a style="color: #1061cc" class="more_detail_btn" href="#description" @click="changeTab('description', 'click')">显示更多
            </a>
          </div>
          <div class="div_hotel_detail_r">
            <div>
              <el-row>
                <button class="s_btn s_btn_small rmargin" style="margin-right: 0" @click="handleJump">
                  {{ $t("DETAIL.BTN1") }}
                </button>
              </el-row>
            </div>
          </div>
        </div>
        <div class="div_hotel_detail_img">
          <div class="detail_big_pic">
            <img :src="
                baseImg ? baseImg : require('@/assets/img/hotel_img_error.png')
              " :onerror="defaultImg" alt="hotelimage" @click="dialogImagePreview = true" />
          </div>
          <div style="height: 35rem">
            <div class="detail_img_r">
              <div class="detail_pic_box">
                <div class="detail_pic_item" v-for="(per, index) in defaultList" :key="index">
                  <img class="detail_pic_item_img" :src="
                      per.url
                        ? per.url
                        : require('@/assets/img/hotel_img_error.png')
                    " :onerror="defaultImg" alt="hotelimage" />
                </div>
              </div>
            </div>
            <div class="detail_img_text">
              <span>{{ $t("DETAIL.MSG1") }}</span><a class="main_link_tab" href="#facilites" @click="changeTab('facilites', 'click')">{{ $t("DETAIL.MSG2") }}</a>
            </div>
          </div>
        </div>
      </div>

      <!--begin detail list-->
      <div style="font-size:1.5rem" class="detail_list_title" id="fixedHeaderRoot" v-if="this.$objBaseInfo.channelId == 'WEB' && this.$objBaseInfo.sourceType === 'CRM'">
          traceid: {{traceid}}
      </div>
      <div class="detail_list_title" id="fixedHeaderRoot">
        <a class="main_link_tab" :class="curr_tab == 'roomtype' ? 'active' : ''" href="javascript:void(0)" @click="changeTab('roomtype', 'click')">{{ $t("DETAIL.ROOMTYPE") }}</a>
        <a class="main_link_tab" :class="curr_tab == 'description' ? 'active' : ''" href="javascript:void(0)" @click="changeTab('description', 'click')">{{ $t("DETAIL.DESCRIPTION") }}</a>
        <a class="main_link_tab" :class="curr_tab == 'facilites' ? 'active' : ''" href="javascript:void(0)" @click="changeTab('facilites', 'click')">{{ $t("DETAIL.FACILITIES") }}</a>
        <a class="main_link_tab" :class="curr_tab == 'policies' ? 'active' : ''" href="javascript:void(0)" @click="changeTab('policies', 'click')">{{ $t("DETAIL.POLICIES") }}</a>
        <a class="main_link_tab" :class="curr_tab == 'co2' ? 'active' : ''" href="javascript:void(0)" @click="changeTab('co2', 'click')">{{ $t("DETAIL.CO2") }}</a>
      </div>
      <div id="roomtype" class="sticky-title"></div>
      <div class="detail_list" id="roomtype">
        <div class="detail_list_select">
          <div class="room_flex">
            <div class="room_dp_panel">
              <date-picker-no-icon :getDate="getDate" @getTimes="getParamsTime"></date-picker-no-icon>
            </div>
            <div class="room_pn_panel room_pn_panel_controls">
              <div class="room_pn_panel_guest"><Guests :roomCount="roomCount" :guestCount="guestCount" :isEditGuestCount="true" @setRoomNum="setRoomNum" @setAdultNum="setGuestNum" :showIcon="false"></Guests></div>
              <div class="room_pn_panel_currency" v-if="$objBaseInfo.destinationType=='I' || $objBaseInfo.isGATCity">
                <el-select class="payment" v-model="currencyType.code" :placeholder="$t('RESULT.CURRENCY')" clearable @change="handleCurrencyChange">
                  <el-option v-for="item in this.currencyOpt" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="room_pn_panel" v-if="$objBaseInfo.channelId === 'WEB'">
              <button class="room_pn_panel_button" @click="toHotelList">{{ $t("DETAIL.SearchNearbyHotels") }}</button>
            </div>
          </div>
          <div style="width:15rem;margin-left:3rem" v-if="$objBaseInfo.channelId === 'WEB' && (!$objBaseInfo.onlyShowBestPrice || $objBaseInfo.sourceType === 'CRM')">
            <el-switch v-model="bestPrice" :active-text="$t('DETAIL.BestPrice')" @change="bestPriceChange()"></el-switch>
          </div>
        </div>

        <div class="detail_list_content">
          <!-- v-if="$objBaseInfo.channelId ==='WEB'"-->
          <room-list  @updateTraceId="traceid = $event"  ref="PC_roomList" :toBookingParams="toBookingParams" :propsValue="getDate" @reChangeHeight="fromList" @setLoading="getLoading" @setListDate="getParamsTime" :changeCurrency="changeCurrency"></room-list>
        </div>

        <!-- <div>
            <detail-room-list-mobile :toBookingParams="toBookingParams" :propsValue = "getDate" @reChangeHeight = "fromList" @setLoading = "getLoading" v-if="$objBaseInfo.channelId ==='MOBILE'" style="margin-top:2%"></detail-room-list-mobile>
          </div>           -->
      </div>
      <div id="description" class="sticky-title"></div>
      <!--end detail list-->
      <div class="tab_item">
        <!--class="infoDetail"-->
        <div class="tab_item_title">
          <span style="">{{ $i18n.locale == "en" ? this.nameEn : this.nameCh }}</span>
        </div>
        <div class="tab_item_content">
          <p>
            {{ $i18n.locale == "en" ? this.descriptionEn : this.descriptionCh }}
          </p>
        </div>
      </div>
      <!-- mobile图标展示区 -->
      <div id="facilites" class="sticky-title"></div>
      <div class="facility" v-if="$objBaseInfo.channelId === 'MOBILE'">
        <div class="tab_item_title">
          <span>{{ $t("DETAIL.TITLE2") }}</span>
        </div>
        <div class="facility_container" v-if="frontDesk.length > 0">
          <div class="fac_title collapse-item" @click="handleCollapseClick($event)"><span>{{ $t("DETAIL.SERVER1") }}</span><i aria-hidden="true" class="el-icon-arrow-right"></i></div>
          <div class="facility_item_box" style="display: none;">
            <template v-for="(form, index) in frontDesk">
              <div v-if="objIcon[form]" :key="index" class="facility_item">
                <svg-icon :icon-class="objIcon[form]" style="float: left" class="icon_comm"></svg-icon>
                <span class="text_comm">{{tooltipContent(form)}}</span>
              </div>
            </template>
          </div>
        </div>
        <div class="facility_container" v-if="restaurant.length > 0">
          <div class="fac_title collapse-item" @click="handleCollapseClick($event)"><span>{{ $t("DETAIL.SERVER2") }}</span><i aria-hidden="true" class="el-icon-arrow-right"></i></div>
          <div class="facility_item_box" style="display: none;">
            <template v-for="(form, index) in restaurant">
              <div v-if="objIcon[form]" :key="index" class="facility_item">
                <svg-icon :icon-class="objIcon[form]" style="float: left" class="icon_comm"></svg-icon>
                <span class="text_comm">{{tooltipContent(form)}}</span>
              </div>
            </template>
          </div>
        </div>
        <div class="facility_container" v-if="infrastructure.length > 0">
          <div class="fac_title collapse-item" @click="handleCollapseClick($event)"><span>{{ $t("DETAIL.SERVER3") }}</span><i aria-hidden="true" class="el-icon-arrow-right"></i></div>
          <div class="facility_item_box" style="display: none;">
            <template v-for="(form, index) in infrastructure">
              <div v-if="objIcon[form]" :key="index" class="facility_item">
                <svg-icon :icon-class="objIcon[form]" style="float: left" class="icon_comm"></svg-icon>
                <span class="text_comm">{{tooltipContent(form)}}</span>
              </div>
            </template>
          </div>
        </div>
        <div class="facility_container" v-if="entertainment.length > 0">
          <div class="fac_title collapse-item" @click="handleCollapseClick($event)"><span>{{ $t("DETAIL.SERVER4") }}</span><i aria-hidden="true" class="el-icon-arrow-right"></i></div>
          <div class="facility_item_box" style="display: none;">
            <template v-for="(form, index) in entertainment">
              <div v-if="objIcon[form]" :key="index" class="facility_item">
                <svg-icon :icon-class="objIcon[form]" style="float: left" class="icon_comm"></svg-icon>
                <span class="text_comm">{{tooltipContent(form)}}</span>
              </div>
            </template>
          </div>
        </div>
        <div class="facility_container" v-if="others.length > 0">
          <div class="fac_title collapse-item" @click="handleCollapseClick($event)"><span>{{ $t("DETAIL.SERVER5") }}</span><i aria-hidden="true" class="el-icon-arrow-right"></i></div>
          <div class="facility_item_box" style="display: none;">
            <template v-for="(form, index) in others">
              <div v-if="objIcon[form]" :key="index" class="facility_item">
                <svg-icon :icon-class="objIcon[form]" style="float: left" class="icon_comm"></svg-icon>
                <span class="text_comm">{{tooltipContent(form)}}</span>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="tab_item" v-if="$objBaseInfo.channelId === 'WEB'">
        <div class="tab_item_title">
          <span>{{ $t("DETAIL.TITLE2") }}</span>
        </div>
        <div class="detail_type" v-if="frontDesk.length > 0">
          {{ $t("DETAIL.SERVER1") }}
          <div class="tab_item_content">
            <div class="facilites">
              <div class="facilites_item">
                <div class="icon_info">
                  <div class="icon_info_panel">
                    <template v-for="(form, index) in frontDesk">
                      <div class="icon_info_item" v-if="objIcon[form]" :key="index">
                        <svg-icon :icon-class="objIcon[form]" style="float: left" class="icon_comm"></svg-icon>
                        <span class="text_comm">{{tooltipContent(form)}}</span>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="detail_type" v-if="restaurant.length > 0">
          {{ $t("DETAIL.SERVER2") }}
          <div class="tab_item_content">
            <div class="facilites">
              <div class="facilites_item">
                <div class="icon_info">
                  <div class="icon_info_panel">
                    <template v-for="(form, index) in restaurant">
                      <div class="icon_info_item" v-if="objIcon[form]" :key="index">
                        <svg-icon :icon-class="objIcon[form]" style="float: left" class="icon_comm"></svg-icon>
                        <span class="text_comm">{{ tooltipContent(form) }}</span>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="detail_type" v-if="infrastructure.length > 0">
          {{ $t("DETAIL.SERVER3") }}
          <div class="tab_item_content">
            <div class="facilites">
              <div class="facilites_item">
                <div class="icon_info">
                  <div class="icon_info_panel">
                    <template v-for="(form, index) in infrastructure">
                      <div class="icon_info_item" v-if="objIcon[form]" :key="index">
                        <svg-icon :icon-class="objIcon[form]" style="float: left" class="icon_comm"></svg-icon>
                        <span class="text_comm">{{tooltipContent(form)}}</span>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="detail_type" v-if="entertainment.length > 0">
          {{ $t("DETAIL.SERVER4") }}
          <div class="tab_item_content">
            <div class="facilites">
              <div class="facilites_item">
                <div class="icon_info">
                  <div class="icon_info_panel">
                    <template v-for="(form, index) in entertainment">
                      <div class="icon_info_item" v-if="objIcon[form]" :key="index">
                        <svg-icon :icon-class="objIcon[form]" style="float: left" class="icon_comm"></svg-icon>
                        <span class="text_comm">{{tooltipContent(form)}}
                        </span>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="detail_type" v-if="others.length > 0">
          {{ $t("DETAIL.SERVER5") }}
          <div class="tab_item_content">
            <div class="facilites">
              <div class="facilites_item">
                <div class="icon_info">
                  <div class="icon_info_panel">
                    <template v-for="(form, index) in others">
                      <div class="icon_info_item" v-if="objIcon[form]" :key="index">
                        <svg-icon :icon-class="objIcon[form]" style="float: left" class="icon_comm"></svg-icon>
                        <span class="text_comm">{{tooltipContent(form)}}
                        </span>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="policies" class="sticky-title"></div>
      <div class="tab_item">
        <div class="tab_item_title">
          <span>
            {{ $t("DETAIL.TITLE3") }}
          </span>
        </div>
        <div class="tab_item_content">
          <div>
            <div id="conditions" class="policy">
              <!-- <div class="title-one-level">{{ $t("DETAIL.CONDITIONS") }}</div> -->
              <div class="policy_content">
                <p v-if="$objBaseInfo.destinationType == 'D'">
                  {{
                    (this.Policy1 == 'false'
                      ? $t("DETAIL.FOREIGNGUESTS1")
                      : $t("DETAIL.FOREIGNGUESTS2"))
                  }}
                </p>
                <p>
                  {{ $t("DETAIL.CHECKINTIME") }} {{ this.checkInTime }}
                  {{ $t("DETAIL.CHECKOUTTIME") }}{{ this.checkOutTime }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="co2" class="sticky-title"></div>
      <div class="tab_item">
        <div class="tab_item_title">
          <span>{{ $t("DETAIL.TITLE4") }}</span>
        </div>
        <div class="tab_item_content">
          <div>
            <div id="conditions" class="policy">
              <div class="policy_content">
                <p>{{ $t('DETAIL.CARBON_EMISSIONS.NIGHTLY', { carbonFootprint: emission.kgOfCO2 ? emission.kgOfCO2.toFixed(2) : 'N/A' }) }}</p>
                <p>{{ $t('DETAIL.CARBON_EMISSIONS.TOTAL', { totalCarbonFootprint: emission.kgOfCO2 && daysDiff ? (emission.kgOfCO2 * daysDiff).toFixed(2) : 'N/A' }) }}</p>
                <p class="description">{{ $t('DETAIL.CARBON_EMISSIONS.DESCRIPTION') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--begin image viewer-->
    <el-dialog width="50%" :title="$t('DETAIL.DIALOGIMAGETITLE')" v-model="dialogImagePreview" :show-close="false" class="dialog-image">
      <el-row>
        <el-col :span="24">
          <el-carousel class="carousel-image" ref="carousel" arrow="always" :autoplay="false">
            <el-carousel-item v-for="(item, index) in PhotoList" :key="index">
              <el-image fit="fill" :src="
                  item.url
                    ? item.url
                    : require('@/assets/img/hotel_img_error.png')
                " :onerror="defaultImg"></el-image>
            </el-carousel-item>
          </el-carousel>
        </el-col>
      </el-row>
      <el-row style="margin-top: 1rem">
        <el-col :span="24" class="image-list-scroll">
          <el-image v-for="(item, index) in PhotoList" :key="index" @click="selectImg(index)" style="width: 100px; height: 80px; margin-right: 1rem" :src="
              item.url ? item.url : require('@/assets/img/hotel_img_error.png')
            " :onerror="defaultImg">
          </el-image>
        </el-col>
      </el-row>
    </el-dialog>
    <!--end image viewer-->
  </div>
</template>

<script>
import RoomList from "./DetailRoomList.vue";
import DateRoom from "../../components/DateRoom.vue";
import { getHotelDetail,getHotelTravelRule } from "@/api/shoppingData.js";
import DatePickerNoIcon from "@/components/DatePickerNoIcon.vue";
import Guests from "@/components/Guests.vue";
import { iconSvg } from "@/config/icon";
import Loading from "@/components/Loading.vue";
import { hideElement,formatDateTime,isCityGAT } from "@/utils/utils.js";
import { getDictionaryItem } from "@/utils/getDictionaryData.js";
// import DetailRoomListMobile from './DetailRoomListMobile.vue';

function parseQueryJsonValue(value) {
  if (typeof value !== "string") {
    return value;
  }
  try {
    return JSON.parse(value);
  } catch (e) {
    return value;
  }
}

export default {
  name: "detail",
  components: {
    DatePickerNoIcon,
    Guests,
    RoomList,
    DateRoom,
    Loading,
    // DetailRoomListMobile
  },
  props: {
    setDataValue: {},
  },
  data() {
    return {
      currencyOpt:[
        { value: "0", label: "USD" },
        { value: "1", label: "EUR" },
        { value: "2", label: "CNY" }
      ],
      currencyType:{ code:""},
      locationArr: [],
      frontDesk: [],
      restaurant: [],
      infrastructure: [],
      entertainment: [],
      others: [],
      defaultList: [],
      defaultImg: 'this.src="' + require("@/assets/img/hotel_img_error.png") + '";this.onerror=null;',
      defaultImgRoom: 'this.src="' + require("@/assets/img/room_img_error.png") + '";this.onerror=null;',
      defultUrl: '@/assets/img/hotel_img_error.png',
      baseImg: null,
      loading: false,
      roomList: true,
      allLoading: true,
      objIcon: iconSvg,
      // 往book页面传递参数
      toBookingParams: {
        paymentType: null,
        hotelcode: "",
        roomTypeId: "",
        hotelCodeType: "",
        checkInDate: "",
        checkOutDate: "",
        noGuests: "",
        noRooms: "",
        hotelInfo: {
          hotelcode: "",
          hotelName: "",
          hotelNameEn: "",
          starRating: "0",
          standardStar: "0",
          contactNumber: "",
          address: "",
          addressEn: "",
          isSupportForeign: "",
          payMethods: "",
          checkInTime: "", //最晚入住时间
          checkOutTime: "", //最晚离店时间
          city: "", //城市code
          group:"",
          countryCode:"",//国家code
          emissionScore: 0,
        },
      },
      // 选择时间控制器后 重新走房型 查询接口

      propsValue: [],
      changeCurrency:"",
      getcheckInDate: "",
      getcheckOutDate: "",
      hotelcode: "",
      roomCount: "",
      guestCount: "",
      cwtCityCode: "",
      cwtCountryCode: "",
      // 返回字段========================
      starRating: 0,
      standardStar: 0,
      emission: {
        kgOfCO2: 0,
        score: 0
      },
      dataSource: [],
      iconInfoList: [],
      contactNumber: "",
      nameEn: "",
      nameCh: "",
      star: null,
      addressEn: "",
      addressCh: "",
      descriptionEn: "",
      descriptionCh: "",
      roomsCount: "",
      PhotoList: [],
      Policy1: "",
      checkInTime: "",
      checkOutTime: "",
      //================================
      // 获取datePicker里的时间参数
      date1: "",
      date2: "",

      //=======
      getDate: [],
      data_value: "",
      value: "1room, 1guest",
      dialogImagePreview: false,
      curr_tab: "roomtype",
      roomHeight: 0,
      descriptionHeight: 0,
      facilitesHeight: 0,
      policiesHeight: 0,
      scrollType: "",
      isShowMap: true,
      decoratedAt: "",
      openedAt: "",
      wifiList:["FCT01205","FCT01203","FCT011418","FCT011491","FCT05202","FCT06811","FCT06204","FCT06862","FCT06864","FCT07810","FCT07809","FCT07863"],
      bestPrice:false,
      daysDiff: 0,//入离时间天数
      traceid:"",//traceid
    };
  },
  created() {
    this.getAllDate();
    if (this.$objBaseInfo.channelId === "MOBILE") {
      this.$nextTick(() => {
        //不显示回退按钮
        let goHistray = document.querySelector(".van-nav-bar__left");
        goHistray.removeAttribute("style");
      });
    }
  },
  methods: {
    goMap() {
      this.$router.push({
        path: "/MapResultMobile",
      });
    },
    // 子组件赋值房间数 guest组件
    setRoomNum(value) {
      this.roomCount = value;
      this.toBookingParams.noRooms = value;
    },
    // 子组件赋值人数 guest组件
    setGuestNum(value) {
      this.guestCount = value;
      this.toBookingParams.noGuests = value;
    },
    fromList() {
      this.changeHeight();
    },
    updateAllLoading() {
      this.allLoading = this.loading || this.roomList;
    },
    getLoading(closeLoading) {
      this.roomList = closeLoading;
      this.updateAllLoading();
    },
    changeHeight() {
      let roomtypeDiv = document.getElementById("roomtype");
      let descriptionDiv = document.getElementById("description");
      let facilitesDiv = document.getElementById("facilites");
      let policiesDiv = document.getElementById("policies");
      this.roomHeight = this.getElementTop(roomtypeDiv);
      this.descriptionHeight = this.getElementTop(descriptionDiv);
      this.facilitesHeight = this.getElementTop(facilitesDiv);
      this.policiesHeight = this.getElementTop(policiesDiv);
      this.$nextTick(function () {
        window.addEventListener("scroll", this.onScroll);
      });
    },
    //选中底部图片设置当前轮播图片
    selectImg(item) {
      this.$refs.carousel.setActiveItem(parseInt(item));
    },
    handleJump: function () {
      location.href = "#roomtype";
    },
    //路由跳转
    toBooking: function () {
      this.$router.push({
        name: "Booking",
        query: { sourceType: this.$objBaseInfo.sourceType },
      });
    },
    changeTab(item, type) {
      if (type == "click") {
        this.scrollType = type;
        this.curr_tab = item;
        document.querySelector("#" + item).scrollIntoView();
      } else {
        if (this.scrollType == "click") {
          this.scrollType = "";
        } else {
          this.curr_tab = item;
        }
      }
    },
    onScroll() {
      let scrolled =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      // 586、1063分别为第二个和第三个锚点对应的距离
      if (scrolled <= parseInt(this.descriptionHeight) - 100) {
        this.changeTab("roomtype", "scroll");
      } else if (
        scrolled < parseInt(this.facilitesHeight) &&
        scrolled >= parseInt(this.descriptionHeight) - 100
      ) {
        this.changeTab("description", "scroll");
      } else if (
        scrolled < parseInt(this.policiesHeight) &&
        scrolled >= parseInt(this.facilitesHeight)
      ) {
        this.changeTab("facilites", "scroll");
      } else {
        this.changeTab("policies", "scroll");
      }
    },
    getElementTop(element) {
      var actualTop = element.offsetTop;
      var current = element.offsetParent;
      while (current !== null) {
        actualTop += current.offsetTop;
        current = current.offsetParent;
      }
      return actualTop;
    },
    async getDetail() {
      this.loading = true;
      this.updateAllLoading();
      let params = {
        params: {
          hotel_id: this.hotelcode,
          posCode: this.$objBaseInfo.poscode,
        },
      };
      await getHotelDetail(params)
        .then((res) => {
          if (res.code == 200) {
            this.loading = false;
            this.locationArr.push(res.data.location);
            this.updateAllLoading();

            if (res.data.contactNumber) {
              this.contactNumber = res.data.contactNumber;
            } else {
              this.contactNumber = "N/A";
            }
            if (res.data.name.en) {
              this.nameEn = res.data.name.en;
            } else {
              this.nameEn = "N/A";
            }
            if (res.data.name["zh-CN"]) {
              this.nameCh = res.data.name["zh-CN"];
            } else {
              this.nameCh = "N/A";
            }
            this.starRating = res.data.starRating;
            this.emission = res.data.emission;
            this.standardStar = res.data.standardStar;
            if (res.data.address.en) {
              this.addressEn = res.data.address.en;
            } else {
              this.addressEn = "N/A";
            }
            if (res.data.address["zh-CN"]) {
              this.addressCh = res.data.address["zh-CN"];
            } else {
              this.addressCh = "N/A";
            }
            if(this.$objBaseInfo.sourceType == "CRM" && (this.$objBaseInfo.isGATCity || this.$objBaseInfo.destinationType == "I"))
            {
              this.nameCh = this.nameEn = this.nameCh +'(' + this.nameEn +')';
              this.addressCh = this.addressEn = this.addressCh +'(' + this.addressEn +')';
            }
            if (res.data.description.en) {
              this.descriptionEn = res.data.description.en;
            } else {
              this.descriptionEn = "N/A";
            }
            if (res.data.description["zh-CN"]) {
              this.descriptionCh = res.data.description["zh-CN"];
            } else {
              this.descriptionCh = "N/A";
            }
            this.roomsCount = res.data.roomsCount;
            this.PhotoList = res.data.photos;
            for (let i = 0; i < 8; i++) {
              if (this.PhotoList[i]) {
                this.defaultList.push(this.PhotoList[i]);
              } else {
                this.defaultList.push(this.defaultImg);
              }
            }
            this.baseImg = this.PhotoList[0].url;
            this.Policy1 = res.data.policies.IsForeignerAllowed;
            if (res.data.policies.checkInTime) {
              this.checkInTime = res.data.policies.checkInTime;
            } else {
              this.checkInTime = "12：00";
            }
            if (res.data.policies.checkInTime) {
              this.checkOutTime = res.data.policies.checkOutTime;
            } else {
              this.checkOutTime = "12：00";
            }
            if(res.data.decoratedAt){
              this.decoratedAt = formatDateTime(res.data.decoratedAt,"YYYY-MM");
            }
            if(res.data.openedAt){
              this.openedAt = formatDateTime(res.data.openedAt,"YYYY-MM");
            }
            this.dataSource = res.data;

            this.dataSource.facilities.filter(col => col !==null).map((col) => {
              if(this.$objBaseInfo.destinationType == "I"||(this.$objBaseInfo.destinationType == "D"&& this.$objBaseInfo.isGATCity)){
                if(this.wifiList.indexOf(col) > -1){
                  return;
                }
              }
              if (col.includes("FCT01") || col.includes("FCT02")) {
                if (this.frontDesk.indexOf(col) == -1) {
                  this.frontDesk.push(col);
                }
              }
              if (col.includes("FCT03") || col.includes("FCT08")) {
                if (this.restaurant.indexOf(col) == -1)
                  this.restaurant.push(col);
              }
              if (
                col.includes("FCT05") ||
                col.includes("FCT07") ||
                col.includes("FCT09")
              ) {
                if (this.infrastructure.indexOf(col) == -1)
                  this.infrastructure.push(col);
              }
              if (col.includes("FCT04")) {
                if (this.entertainment.indexOf(col) == -1)
                  this.entertainment.push(col);
              }
              if (col.includes("FCT06")) {
                if (this.others.indexOf(col) == -1)
                  this.others.push(col);
              }
              return col;
            });
            //booking 需要字段
            //start booking page
            this.toBookingParams.hotelInfo.hotelcode = this.hotelcode;
            this.toBookingParams.hotelInfo.hotelName = res.data.name;
            this.toBookingParams.hotelInfo.starRating = res.data.starRating;
            this.toBookingParams.hotelInfo.standardStar = res.data.standardStar;
            this.toBookingParams.hotelInfo.contactNumber =
              res.data.contactNumber;
            this.toBookingParams.hotelInfo.address = res.data.address;
            this.toBookingParams.hotelInfo.isSupportForeign =
              res.data.policies.IsForeignerAllowed; //是否支持外宾
            this.toBookingParams.hotelInfo.payMethods =
              res.data.policies.payMethods; //付款方式
            this.toBookingParams.hotelInfo.checkInTime =
              res.data.policies.checkInTime; //最晚入住时间
            this.toBookingParams.hotelInfo.checkOutTime =
              res.data.policies.checkOutTime; //最晚离店时间
            // this.toBookingParams.hotelInfo.city = res.data.city; //城市code
            this.toBookingParams.hotelInfo.group = res.data.group; //集团名称
            this.toBookingParams.hotelInfo.emissionScore = this.emission.score;
            //end booking page
            if(this.$objBaseInfo.showTravelTitle){
              this.getPersonalizationTravelRule();
            }
          } else {
            this.loading = false;
            this.updateAllLoading();
          }
        })
        .catch((err) => {
          this.loading = false;
          this.updateAllLoading();
        });
    },
    setCheckDate(val) {
      // 再次请求 房间类型接口
    },
    getAllDate() {
      this.getcheckInDate = this.$route.query.checkInAt;
      this.getcheckOutDate = this.$route.query.checkOutAt;
      this.hotelcode = this.$route.query.hotelcode;
      this.roomCount = this.$route.query.roomCount;
      this.guestCount = this.$route.query.guestCount;
      this.cwtCityCode = this.$route.query.cwtCityCode;
      this.cwtCountryCode = this.$route.query.cwtCountryCode;
      this.getDate = [this.getcheckInDate, this.getcheckOutDate];
      this.toBookingParams.hotelcode = this.hotelcode;
      this.toBookingParams.roomTypeId = "";
      this.toBookingParams.hotelCodeType = "";
      this.toBookingParams.checkInDate = this.getcheckInDate;
      this.toBookingParams.checkOutDate = this.getcheckOutDate;
      this.toBookingParams.noGuests = this.guestCount;
      this.toBookingParams.noRooms = this.roomCount;
      this.toBookingParams.hotelInfo.isAp = this.$route.query.isAp
        ? this.$route.query.isAp
        : false;
      this.toBookingParams.hotelInfo.isCp = this.$route.query.isCp
        ? this.$route.query.isCp
        : false;
      this.toBookingParams.hotelInfo.latitude = this.$route.query.latitude;
      this.toBookingParams.hotelInfo.longitude = this.$route.query.longitude;
      this.toBookingParams.paymentType = this.$route.query.paymentType;
      this.toBookingParams.hotelInfo.city = this.cwtCityCode; //城市code
      this.toBookingParams.hotelInfo.countryCode = this.cwtCountryCode; //国家code
      this.changeCurrency = this.$route.query.currencyCode;
      this.currencyType.code=  this.changeCurrency;
      this.toBookingParams.groupId = this.$route.query.groupId;
      if(this.$route.query.hasOwnProperty("cwtMark"))
      {
        if(this.$route.query.cwtMark!=undefined && this.$route.query.cwtMark!=null)
        {
          this.toBookingParams.cwtMark = parseQueryJsonValue(this.$route.query.cwtMark);
        }
      }
      if(this.toBookingParams.hotelInfo.countryCode == "100000"){
        this.$objBaseInfo.destinationType = "D";
      }else{
        this.$objBaseInfo.destinationType = "I";
      }
      this.$objBaseInfo.isGATCity = isCityGAT(this.cwtCityCode);
    },
    getParamsTime(value) {
      if (this.getDate != value) {
        this.getDate = value;
      }
      this.allLoading = false;
    },
    handleCollapseClick(event) {
      if (event.currentTarget.className.indexOf("active") == -1) {
        event.currentTarget.classList.add("active");
        event.currentTarget.nextSibling.style.display = "";
        event.currentTarget.lastChild.classList.add("active");
      } else {
        event.currentTarget.className = event.currentTarget.className.replace("active", "");
        event.currentTarget.nextSibling.style.display = "none";
        event.currentTarget.lastChild.className = event.currentTarget.lastChild.className.replace("active", "");
      }
    },
    handleCurrencyChange(data) {
      this.changeCurrency = data;
    },
    getPersonalizationTravelRule(){
      var policyParms = {
        params: {
          customerCode: this.$objBaseInfo.customerCode,
          cityCode: this.toBookingParams.hotelInfo.city,
          countryCode: this.cwtCountryCode,
          bookingContactId: this.$objBaseInfo.loginID,
          hotelCode: this.hotelcode,
        }
      }
      getHotelTravelRule(policyParms)
      .then((res) => {
        this.$objBaseInfo.displayTravelRules = true;
        if (res.code == 200 && res.data) {
          this.$objBaseInfo.personalizationPolicyInfo = res.data.travelrule;
          this.$objBaseInfo.displayTravelRules = res.data.travelrule.isShowTravelTitle;
        }else{
          this.$objBaseInfo.personalizationPolicyInfo = "";
        }
      });
    },
    toHotelList(){
      var cityInfo = {
        cityCode: this.cwtCityCode,
        cityInfo:{
          countryCode: this.toBookingParams.hotelInfo.countryCode
        }
      };
      let searchParam = {
        city: cityInfo,
        checkInAt: this.toBookingParams.checkInDate,
        checkOutAt: this.toBookingParams.checkOutDate,
        roomCount: this.roomCount,
        guestCount: this.guestCount,
        keyword: '',
        keywordType: '',
        centerPointHotelId: this.hotelcode,
      };
      // result 页面  map:  页面
      // 跳转页面
      this.$store.commit("changePathQuery", searchParam);
      this.$router.push({
        name: 'Result',
        query: {
          searchParam: JSON.stringify(searchParam),
          sourceType: this.$objBaseInfo.sourceType,
        },
      });
    },
    bestPriceChange(){
      const index = this.$refs.PC_roomList.filterGroup.indexOf(15);
      if (index !== -1) {
        this.$refs.PC_roomList.filterGroup.splice(index, 1);
      } 
      if(this.bestPrice){
        this.$refs.PC_roomList.filterGroup.push(15);
      }
      this.$refs.PC_roomList.filterRoomTypeList();
    },
    tooltipContent(facility) {
      const facilityData = getDictionaryItem(facility,"facility");
      if (!facilityData) return '';
      const translatedKey = this.$t("DETAIL.RESPONSEDATA.facility");
      return facilityData[translatedKey] || '';
    },
  },
  computed: {
    separator() {
      return "| ";
    }
  },
  mounted() {
    //判断来源 CRM跳转过来隐藏部分元素
    hideElement(this);
    if (sessionStorage.getItem("mapData")) {
      this.isShowMap = true;
    } else {
      this.isShowMap = false;
    }
    if(this.$objBaseInfo.onlyShowBestPrice){
      this.bestPrice = true;
    }
    this.getDetail();
    this.changeHeight();
  },
  watch: {
    reLoadRooms: function () { },
    getDate: function (newDate) {
      this.getDate = newDate;
      this.daysDiff = (new Date(newDate[1]) - new Date(newDate[0])) / (1000 * 60 * 60 * 24);
    },
  },
};
</script>

<style lang="stylus" scoped>
// mobile serve
@media screen and (max-width: 960px) {
  ::v-deep .el-carousel__container {
    position: relative;
    width: 100%;
    height: 25rem;
  }

  .fac_title {
    // font-size: 1.8rem;
    padding-bottom: 1rem;
    font-weight: 600;
    span{
      margin-right: 1rem;
    }
  }

  .collapse-item{
    i.active{
      transform: rotate(90deg);
    }
  }

  .hotel_container_panel {
    width: 100%;
    padding: 0;
  }

  .showMap {
    padding-top: 1%;
    color: #1061cc;
    padding-left: 3%;
    display: flex;
    align-items: center;
    gap: 0.4rem;
  }

  .showMap .show-map-icon {
    width: 1.8rem;
    height: 1.8rem;
  }

  .carousel-image {
    width: 100%;
  }

  .wordBtn {
    padding-left: 20%;
  }

  .imgStyle {
    width: 100%;
    height: 70vw;
  }

  .mainBox {
    background: #f1f3f5;
    position: relative;
    z-index: 0;
  }

  .tagContent {
    margin-left: 1%;
    width: 100%;
    z-index: 9;
    word-wrap: break-word;
    height: 100%;
  }

  .device_btn {
    height: 100%;
    margin-top: 5%;
    margin-left: 3%;
  }

  .detailContent {
    padding: 1rem 0;
    font-size: 1.4rem;
    width: 100%;
    // height: 33vw;
    background: white;

    ul {
      padding: 0 3%;
      display: flex;
      flex-direction: column;

      li:first-child{
        padding-bottom: 0.7rem;
      }

      li {
        line-height: 2rem;
        padding-bottom: 1%;
        display: inline-block;

        h1 {
          display: inline;
          font-size: 2rem;
          line-height: 2.5rem;
          margin-right: 1.3rem;
        }

        svg {
          padding-right: 0.5rem;
        }

        svg.icon-star {
          padding-right: 0;
          width: 1.4rem;
          height: 1.4rem;
        }
      }
    }
  }

  .detail_list_title {
    display: flex;
    justify-content: space-around;
    font-family: 'Source-Sans-Pro-Semibold';
    left: 0px;
    margin-top: 0.5rem;
    border-bottom: 0.2rem solid $bg-color;
    height: 46px;
    line-height: 46px;
    background-color: $btn-font-color;
    position: sticky;
    top: 0;
    z-index: 30;
    font-weight: 600;
    a.main_link_tab {
      color:#1061cc;
      font-size: 1.6rem;
      height: 23px;
      line-height: 23px;
      padding: 11px 0;
      text-decoration: none;
    }

    a.main_link_tab.active {
      color: $font-color;
      border-bottom: 0.2rem solid $btn-bg-color;
    }
  }

  .sticky-title {
    width: 100%;
    margin-top: -4rem;
    padding-top: 4rem;
  }

  .detail_list {
    background: #f1f3f5;
    padding-top: 1%;
    width: 100%;
  }

  .detail_list_select {
    width: 100%;
    height: 13rem;
    background: #f1f3f5;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }

  .dateList_flex {
  }

  .room_dp_panel ::v-deep {
    width: 90%;
    margin-left: 4%;

    .el-input__inner {
      height: 5rem;
      line-height: 5rem;
      background-color: $btn-font-color;

      .dp_last_lable {
        width: 9rem;
        padding-right: 0;
        font-size: 1.2rem;
      }

      .el-range-separator {
        font-size: 1.2rem;
      }

      .el-range-input {
        font-size: 1.2rem;
        // padding-left: 3%;
      }

      .dp_first_lable {
        font-size: 1.2rem;
        position: absolute;
        top: -2.5rem;
        width: 6.5rem;
        height: 2rem;
        text-align: left;
        padding-left: 1.2rem;
      }
    }
  }

  .room_pn_panel ::v-deep {
    width: 90%;
    margin-left: 4%;
    display: flex;

    .el-input__inner {
      height: 5rem;
      line-height: 5rem;
      background-color: #E7E9EA;
    }
    .room_pn_panel_guest {
      flex: 4;
    }
    .room_pn_panel_currency {
      flex: 2;
      margin-left: 1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 12rem;
    }
    .room_pn_panel_currency .payment {
      width: 100%;
      min-width: 11rem;
    }
  }

  .infoDetail {
    background-color: $btn-font-color;
    width: 100%;
  }

  .facility {
    background-color: $btn-font-color;
    width: 100%;
  }

  .facility_container {
    // padding-left: 2%;
    // width: 100%;
    margin: 2% 2% 0 2%;
    font-size: 1.4rem;
    margin-top: 2%;
    // border-bottom: 0.1rem solid $gray-bg-color;
  }
  .facility_container:not(:last-child)  {
    border-bottom: 0.1rem solid $gray-bg-color;
  }

  .facility_item_box {
    // margin-top: 1%;
    display: flex;
    flex-wrap: wrap;
  }

  .facility_item {
    // height:30px;
    margin: 5px;
    width: 40%;
    display: flex;
  }

  .pickList {
    background-color: $btn-font-color;
    padding-top: 0.1rem;
  }

  .more_detail {
    font-size: 1.4rem;
    margin-top: 7.5rem;
    margin-left: -20rem;
    cursor: pointer;
    color: #1061cc;
  }

  .icon_comm {
    display: inline-block;
    height: 1.3rem;
    width: 1.3rem;
    margin-top: 0.3rem;
    flex: 1;
  }

  .text_comm {
    // padding-left:1rem;
    line-height: 2rem;
    flex: 4;
  }

  .detail_type {
    font-size: 1.4rem;
    padding: 1rem;
    /* font-weight: 900; */
  }

  .wordList {
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    display: -webkit-box;
  }

  .rmargin {
    margin-right: 0;
  }

  .nev {
    height: 5rem;
    line-height: 5ren;
  }

  .div_hotel_detail {
    background-color: $btn-font-color;
    padding: 1.3rem 20px 1.3rem;
  }

  .div_hotel_detail_text {
    display: flex;
    justify-content: space-between;
  }

  .div_hotel_detail_l {
    font-size: 1.4rem;
    width: 60%;

    ul {
      display: flex;
      flex-direction: column;

      li {
        line-height: 2rem;
        padding-bottom: 1.4rem;
        display: inline-block;

        h1 {
          display: inline;
          font-size: 1.8rem;
          font-weight: 600;
          line-height: 2.5rem;
          margin-right: 1.3rem;
          color: #222A30;
          font-family: 'Source Sans Pro';
        }

        svg {
          padding-right: 1rem;
        }

        svg.icon-star {
          padding-right: 0;
          width: 1.4rem;
          height: 1.4rem;
        }
      }
    }
  }

  .div_hotel_detail_r {
    text-align: right;
    display: flex;
    flex-direction: column-reverse;

    span.price {
      font-size: 3rem;
    }

    span.price:before {
      content: attr(data-content-before);
      font-size: 2rem;
      padding-right: 1rem;
    }

    span.price:after {
      content: attr(data-content-after);
      font-size: 2rem;
    }

    span.price {
      content: attr(data-content);
      font-size: 2rem;
    }
  }

  .div_hotel_detail_img {
    display: flex;
    flex-direction: row;
  }

  .detail_big_pic {
    width: 70rem;
    height: 33rem;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .detail_img_r {
    width: 70rem;
    height: 30rem;
    display: flex;
    flex-direction: column;
  }

  .detail_pic_box {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .detail_img_text {
    margin-left: 2%;
    height: 3rem;
    font-size: 1.4rem;

    span {
      text-overflow: ellipsis;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
    }

    a {
      text-overflow: ellipsis;
      width: 20%;
      white-space: nowrap;
      overflow: hidden;
      text-decoration-line: none;
    }
  }

  .detail_pic_item {
    width: 16rem;
    height: 14rem;
    margin-bottom: 1rem;
    padding-left: 1rem;
  }

  .detail_pic_item_img {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .tab_item {
    background-color: $btn-font-color;
    width: 100%;
  }

  .tab_item_title {
    padding: 1.3rem;
    border-bottom: 0.1rem solid $btn-bg-color;
    margin: 1.3rem 0;

    span {
      font-size: 1.8rem;
      height: 2rem;
      line-height: 2rem;
      font-weight: bold;
    }
  }

  .tab_item_content {
    padding: 1rem;
    font-size: 1.4rem;
  }

  .facilites {
    display: flex;
    flex-direction: column;

    .title {
      display: inline-block;
      font-size: 1.4rem;
      width: 16%;
    }

    .icon_info {
      display: inline-block;
      font-size: 1.2rem;
      width: 100%;
    }

    .icon_info_panel {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
    }

    .icon_info_item {
      margin-right: 2rem;
      margin-bottom: 1rem;
      width: 30rem;
      height: 2rem;
    }
  }

  .facilites_item {
    margin-bottom: 1rem;
  }

  .policy {
    margin-bottom: 1.3rem;

    .title-one-level {
      font-size: 1.4rem;
      line-height: 2ren;
    }
  }

  .policy_content {
    font: size 1.2rem;
    line-height: 1.7ren;

    .title {
      margin-right: 1.2rem;
    }
  }

  .svg {
    vertical-align: -0.2rem;
    width: 1.6rem;
    height: 1.6rem;
  }

  .dialog-image {
    margin-top: -10vh;

    ::v-deep .el-dialog {
      // height: 33.33vw;
      max-width: 70rem;
      max-height: 47.9rem;
    }
  }

  ::v-deep .dialog-image .el-dialog {
    background: rgba(0, 0, 0, 0.7);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);

    .el-carousel__indicators--horizontal {
      display: none;
    }

    .el-image {
      width: 100%;
      height: 100%;
    }

    .el-dialog__title {
      font-family: PingFang SC;
      color: $btn-font-color;
      /* font-weight: 600; */
    }

    .el-dialog__body {
      padding: 1%;
    }
  }

  ::v-deep .dialog-image .el-icon-arrow-right:before, ::v-deep .dialog-image .el-icon-arrow-left:before {
    font-size: 3rem;
    font-weight: bold;
  }

  .image-list-scroll {
    white-space: nowrap;
    overflow: auto;

    // display: flex;
    &::-webkit-scrollbar {
    }

    &::-webkit-scrollbar-track-piece { // 滚动条凹槽的颜色，还可以设置边框属性
      background-color: $scrollbar-bg-color;
      border-radius: 10px;
    }

    &::-webkit-scrollbar { // 滚动条的宽度
      width: 9px;
      height: 9px;
    }

    &::-webkit-scrollbar-thumb { // 滚动条的设置
      background-color: $scrollbar-thumb-color;
      background-clip: padding-box;
      min-height: 28px;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: $scrollbar-thumb-hover-color;
    }
  }

  .content-title {
    font-size: 1.4rem;
    color: orange;
  }

  .room_flex {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .dp_no_icon ::v-deep .el-input__wrapper, .room_pn_panel ::v-deep .el-input__wrapper {
    height: 5rem;
    line-height: 5rem;
    background-color: #E7E9EA;
  }

  ::v-deep .el-range-editor .el-range-input {
    background-color: #E7E9EA;
    width: 35%;
  }

  ::v-deep .van-calendar__day {
    height: 6rem;
    font-size: 1.2rem;
  }

  ::v-deep .van-calendar__bottom-info, .van-calendar__top-info {
    font-size: 1rem;
    line-height: 1.2rem;
  }
  .more_detail_btn{
    font-weight: 600;
  }
}

// web server
@media screen and (min-width: 961px) {
  .icon_comm {
    display: inline-block;
    height: 2rem;
  }

  .text_comm {
    padding-left: 1rem;
    line-height: 2rem;
  }

  .detail_type {
    font-size: 1.4rem;
    padding: 1rem;
    /* font-weight: 900; */
  }

  .wordList {
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    display: -webkit-box;
  }

  .rmargin {
    margin-right: 0;
  }

  .nev {
    height: 5rem;
    line-height: 5ren;
  }

  .div_hotel_detail {
    background-color: $btn-font-color;
    padding: 1.3rem 20px 1.3rem;
  }

  .div_hotel_detail_text {
    display: flex;
    justify-content: space-between;
  }

  .div_hotel_detail_l {
    font-size: 1.4rem;
    width: 60%;

    ul {
      display: flex;
      flex-direction: column;

      li {
        line-height: 2rem;
        padding-bottom: 1.4rem;
        display: inline-block;

        h1 {
          display: inline;
          font-size: 1.8rem;
          font-weight: 600;
          line-height: 2.5rem;
          margin-right: 1.3rem;
          color: #222A30;
          font-family: 'Source Sans Pro';
        }

        svg {
          padding-right: 1rem;
        }

        svg.icon-star {
          padding-right: 0;
          width: 1.4rem;
          height: 1.4rem;
        }
      }
    }
  }

  .div_hotel_detail_r {
    text-align: right;
    display: flex;
    flex-direction: column-reverse;

    span.price {
      font-size: 3rem;
    }

    span.price:before {
      content: attr(data-content-before);
      font-size: 2rem;
      padding-right: 1rem;
    }

    span.price:after {
      content: attr(data-content-after);
      font-size: 2rem;
    }

    span.price {
      content: attr(data-content);
      font-size: 2rem;
    }
  }

  .div_hotel_detail_img {
    display: flex;
    flex-direction: row;
  }

  .detail_big_pic {
    width: 70rem;
    height: 33rem;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .detail_img_r {
    width: 70rem;
    height: 30rem;
    display: flex;
    flex-direction: column;
  }

  .detail_pic_box {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .detail_img_text {
    height: 3rem;
    line-height: 3rem;
    background-color: $bg-color;
    font-size: 1.4rem;
    padding-left: 1.3rem;
    margin-left: 1.3rem;
    display: flex;
    justify-content: space-between;

    span {
      text-overflow: ellipsis;
      width: 80%;
      white-space: nowrap;
      overflow: hidden;
    }

    a {
      text-overflow: ellipsis;
      width: 20%;
      white-space: nowrap;
      overflow: hidden;
      text-decoration-line: none;
    }
  }

  .detail_pic_item {
    width: 16rem;
    height: 14rem;
    margin-bottom: 1rem;
    padding-left: 1rem;
  }

  .detail_pic_item_img {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .detail_list {
    background-color: $btn-font-color;
    padding-top: 0.1rem;
  }

  .detail_list_title {
    left: 0px;
    margin-top: 0.5rem;
    border-bottom: 0.2rem solid $bg-color;
    height: 4rem;
    line-height: 4rem;
    background-color: $btn-font-color;
    position: sticky;
    top: 0;
    z-index: 30;
    font-weight: 600;
    a.main_link_tab {
      margin-right: 3.3rem;
      font-size: 1.8rem;
      height: 2rem;
      line-height: 2rem;
      padding: 1rem 1.3rem;
      text-decoration: none;
    }

    a.main_link_tab.active {
      color: $font-color;
      border-bottom: 0.2rem solid $btn-bg-color;
    }
  }

  .tab_item {
    background-color: $btn-font-color;
  }

  .tab_item_title {
    padding: 1.3rem;
    border-bottom: 0.1rem solid $btn-bg-color;
    margin: 1.3rem 0;

    span {
      font-size: 1.4rem;
      height: 2rem;
      line-height: 2rem;
      font-weight: bold;
    }
  }

  .tab_item_content {
    padding: 1rem;
    font-size: 1.3rem;
  }

  .facilites {
    display: flex;
    flex-direction: column;

    .title {
      display: inline-block;
      font-size: 1.4rem;
      width: 16%;
    }

    .icon_info {
      display: inline-block;
      font-size: 1.2rem;
      width: 100%;
    }

    .icon_info_panel {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
    }

    .icon_info_item {
      margin-right: 2rem;
      margin-bottom: 1rem;
      width: 30rem;
      height: 2rem;
    }
  }

  .facilites_item {
    margin-bottom: 1rem;
  }

  .policy {
    margin-bottom: 1.3rem;

    .title-one-level {
      font-size: 1.4rem;
      line-height: 2ren;
    }
  }

  .policy_content {
    font: size 1.2rem;
    line-height: 1.7ren;

    .title {
      margin-right: 1.2rem;
    }
  }

  .svg {
    vertical-align: middle;
  }

  .dialog-image {
    margin-top: -10vh;

    ::v-deep .el-dialog {
      // height: 33.33vw;
      max-width: 70rem;
      max-height: 47.9rem;
    }
  }

  ::v-deep .dialog-image .el-dialog {
    background: rgba(0, 0, 0, 0.7);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);

    .el-carousel__indicators--horizontal {
      display: none;
    }

    .el-image {
      width: 100%;
      height: 100%;
    }

    .el-dialog__title {
      font-family: PingFang SC;
      color: $btn-font-color;
      /* font-weight: 600; */
    }

    .el-dialog__body {
      padding: 1%;
    }
  }

  ::v-deep .dialog-image .el-icon-arrow-right:before, ::v-deep .dialog-image .el-icon-arrow-left:before {
    font-size: 3rem;
    font-weight: bold;
  }

  .image-list-scroll {
    white-space: nowrap;
    overflow: auto;

    // display: flex;
    &::-webkit-scrollbar {
    }

    &::-webkit-scrollbar-track-piece { // 滚动条凹槽的颜色，还可以设置边框属性
      background-color: $scrollbar-bg-color;
      border-radius: 10px;
    }

    &::-webkit-scrollbar { // 滚动条的宽度
      width: 9px;
      height: 9px;
    }

    &::-webkit-scrollbar-thumb { // 滚动条的设置
      background-color: $scrollbar-thumb-color;
      background-clip: padding-box;
      min-height: 28px;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: $scrollbar-thumb-hover-color;
    }
  }

  .detail_list_select {
    width: 80%;
    display: flex;
    align-items: center;
    margin: 1rem;
  }

  .sticky-title {
    margin-top: -4rem;
    padding-top: 4rem;
  }

  .content-title {
    font-size: 1.4rem;
    color: orange;
  }

  .room_flex {
    display: flex;
  }

  .room_dp_panel {
    width: 65%;
    margin-right: 1.3rem;
  }

  .room_pn_panel {
    display: flex;
    div {
      flex: 1;
    }
  }
  .room_pn_panel_controls {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
  .room_pn_panel_controls .room_pn_panel_guest {
    flex: 1 1 auto;
    min-width: 0;
  }
  .room_pn_panel_controls .room_pn_panel_currency {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 1 auto;
    min-width: 12rem;
  }
  .room_pn_panel_controls .room_pn_panel_currency .payment {
    width: auto;
    min-width: 12rem;
    max-width: 16rem;
  }
  .room_pn_panel_controls .room_pn_panel_currency :deep(.el-select),
  .room_pn_panel_controls .room_pn_panel_currency :deep(.el-input),
  .room_pn_panel_controls .room_pn_panel_currency :deep(.el-input__wrapper) {
    width: 100%;
    min-width: 0;
  }
  .room_pn_panel_button{
    background-color: #fc6640;
    color: #fff;
    border: 0px;
    border-radius: 0.3rem;
    font-family: Source-Sans-Bold;
    margin-left: 2rem;
    font-size: 1.4rem;
    min-width:15rem;
  }
  .dp_no_icon ::v-deep .el-input__inner, .room_pn_panel ::v-deep .el-input__wrapper {
    height: 5rem;
    line-height: 5rem;
    background-color: #E7E9EA;
  }

  ::v-deep .el-range-editor .el-range-input {
    background-color: #E7E9EA;
  }

  .more_detail {
    font-size: 1.4rem;
    margin-top: 7.5rem;
    margin-left: -20rem;
    cursor: pointer;
    color: #1061cc;
  }
  .payment {
    margin-left: 1rem;
  }
  .room_pn_panel_currency .payment {
    margin-left: 0;
  }
  .more_detail_btn{
    font-weight: 600;
  }
}

</style>
